import React from 'react';

import styles from './Category.module.scss';

const EmptyCategoryContent: React.FC<{
  emptyComponentText?: string;
}> = ({
  emptyComponentText = 'Unfortunately, there are currently no games available.',
}) => {
  return (
    <div className={styles.emptyCategory}>
      <p>{emptyComponentText}</p>
    </div>
  );
};

export default EmptyCategoryContent;
